import React from 'react';
import Backend from '../../../../Layouts/Backend';
import { withTranslation } from 'react-i18next';
import Datagrid from '../../../../UI/Datagrid';
import LoadingButton from '../../../../UI/LoadingButton';
import helper from '../../../../../utils/helper';
import PasswordConfirmation from '../../../../UI/PasswordConfirmation';

const ConfigureSensorsPage = (props) => {
  const { t, alarmMaps, columns, defaultSorted, isSubmitting } = props;
  function getSelected() {
    const result = alarmMaps.filter((alarmMap) => alarmMap.active);
    if (result.length) {
      return result.map((r) => r.sensorId);
    } else return [];
  }
  const [selected, setSelected] = React.useState(getSelected());
  const handleOnSelect = (row, isSelect) => {
    if (isSelect) {
      setSelected([...selected, row.sensorId]);
    } else {
      setSelected(selected.filter((x) => x !== row.sensorId));
    }
  };
  const handleOnSelectAll = (isSelect, rows) => {
    const ids = rows.map((r) => r.sensorId);
    if (isSelect) {
      setSelected((selected) => [
        ...selected,
        ...ids.filter((id) => !selected.includes(id)),
      ]);
    } else {
      setSelected((selected) =>
        selected.filter((sensorId) => !ids.includes(sensorId)),
      );
    }
  };
  const selectRow = {
    mode: 'checkbox',
    clickToSelect: true,
    selected: selected,
    onSelect: handleOnSelect,
    onSelectAll: handleOnSelectAll,
  };
  const [openModal, setOpenModal] = React.useState(false);
  const isRequireConfirmation = helper.isRequireConfirmation();
  function onConfigureSensors(e) {
    e.preventDefault();
    if (isRequireConfirmation) {
      setOpenModal(true);
    } else {
      props.onConfigureSensors(selected);
    }
  }
  return (
    <Backend
      title={`Configure Sensors: ${props.remoteName} (ID: ${props.alarmIndicatorId})`}
    >
      <div className="content-inner">
        <PasswordConfirmation
          isOpen={openModal}
          onCancel={() => setOpenModal(false)}
          onConfirm={() => {
            setOpenModal(false);
            props.onConfigureSensors(selected);
          }}
        />
        <Datagrid
          datagridProps={{
            keyField: 'sensorId',
            data: alarmMaps,
            columns,
            defaultSorted,
            selectRow,
          }}
          noExport
        />
        <LoadingButton
          id="configure-sensors-indicator"
          classes="button button-primary mt-20"
          loading={isSubmitting}
          onClick={onConfigureSensors}
        >
          <i className="md-icon">done</i>
          {t('Configure')}
        </LoadingButton>
      </div>
    </Backend>
  );
};

export default withTranslation('app')(ConfigureSensorsPage);
